import React from "react";
import $events from '../../../../blocs/EventBloc';

export default class TutorialContentStart extends React.Component {
    constructor( props ) {
        super(props);

    }

    onStartTutorial(e) {
        e.preventDefault();
        e.stopPropagation();
        $events.$emit('tutorial/start');
    }

    onSkipTutorial(e) {
        e.preventDefault();
        e.stopPropagation();
        $events.$emit('tutorial/skip');
    }

    render() {
        return (
            <div>
                <h3 className="bottom-modal__title">
                    Herzlich Willkommen
                </h3>

                <div className="rte-content">
                    <p dangerouslySetInnerHTML={{__html: this.props.currentState.obj.tutorial_fields.intro_text}} className="strong"></p>

                    <hr/>

                    <div className="column  [ margin__bottom--small ]">
                        <button className="button" onClick={(ev) => this.onStartTutorial(ev)}>
                            Einführung starten
                        </button>

                        <button className="button  button--ghost" onClick={(ev) => this.onSkipTutorial(ev)}>
                            Einführung überspringen
                        </button>
                    </div>

                    <div dangerouslySetInnerHTML={{__html: this.props.currentState.obj.content}}></div>
                </div>
            </div>
        );
    }

}
